export default __webpack_public_path__ + "static/media/avatar_124.3187dfba.png";